import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RichiestaSequenziamentoDNAResponse } from '../model/richiesta-sequenziamento-dna.better.entity';
import { RisultatiSequenziamento } from '../model/risultati-sequenziamento.better.entity';
import { Richiesta_Cariotipo } from '../model/richiesta-cariotipo.better.entity';
import { RisultatiCariotipo } from '../model/risultati-cariotipo.better.entity';
import { KbGene } from '../model/kb-gene.better.entity';
import { Farmaci } from '../model/farmaci.model';
import { GeneTotal } from '../model/gene-total-better.entity';
import { RichiestaSequenziamento } from '../model/lista-richieste-sequenziamento.better';

@Injectable({
  providedIn: 'root'
})
export class BetterService {

  constructor(private http: HttpClient) { }

  generateEhrId(codiceFiscale: string) {
    const username = 'admin';
    const password = 'VZmspUz8R3N2';
    const basicAuth = 'Basic ' + btoa(`${username}:${password}`);

    const headers = new HttpHeaders({
      'Authorization': basicAuth
    });

    return this.http.post<any>(
      environment.betterResourceUrl + '/ehr',
      {
        params: {
          subjectId: codiceFiscale,
          subjectNamespace: 'default',
        }
      },
      { headers: headers }  // Aggiungi l'header qui
    );
  }

  getRichiesteSequenziamento(ehrId: string) {
    let url = environment.betterResourceUrl + '/view/Richieste?ehrid=' + ehrId;
    return this.http.get<RichiestaSequenziamentoDNAResponse[]>(url);
  }
  getRichiesteCollegato(id: string) {
    let url = environment.betterResourceUrl + '/view/sequenziamento?Richiesta_ID=' + id;
    return this.http.get<any>(url);
  }
  getCariotipoCollegato(id: string) {
    let url = environment.betterResourceUrl + '/view/cariotipo?Richiesta_ID=' + id;
    return this.http.get<any>(url);
  }
getKbGene(ehrId:string){
  let url =environment.betterResourceUrl+'/view/Ricerca_geni?EHRID='+ehrId;
 return this.http.get<KbGene[]>(url);
}
getListaFarmaci(ehrId:string){
  let url =environment.betterResourceUrl+'/view/Lista_farmaci?ehrid='+ehrId;
 return this.http.get<Farmaci[]>(url);
}
getAllRichieste(){
  let url =environment.betterResourceUrl+'/view/Retrieve_richieste'
 return this.http.get<RichiestaSequenziamento[]>(url);
}
getAllRisultatiSeq(){
  let url =environment.betterResourceUrl+'/view/Retrieve_richieste_sequenziamento'
 return this.http.get<RichiestaSequenziamento[]>(url);
}
getAllRichiesteCariotipo(){
  let url =environment.betterResourceUrl+'/view/Retrieve_richieste_cariotipo'
 return this.http.get<RichiestaSequenziamento[]>(url);
}
getAllAnalisiCariotipo(){
  let url =environment.betterResourceUrl+'/view/Retrieve_richieste_analisi'
 return this.http.get<RichiestaSequenziamento[]>(url);
}
getRisultatiSequenziamento(ehrId:string){
 let url =environment.betterResourceUrl+'/view/risultati_sequenziamento?ehrid='+ehrId;
return this.http.get<RisultatiSequenziamento[]>(url);
}
getRichiestaCariotipo(ehrId:string){
let url =environment.betterResourceUrl+'/view/richiesta_cariotipo?ehrid='+ehrId;
return this.http.get<Richiesta_Cariotipo[]>(url);
}
getRisultatiCariotipo(ehrId:string){
let url =environment.betterResourceUrl+'/view/risultati_cariotipo?ehrid='+ehrId;
return this.http.get<RisultatiCariotipo[]>(url);
}
getGeneTotal(){
  let url =environment.betterResourceUrl+'/view/gene_total';
 return this.http.get<GeneTotal[]>(url);
}
getAllergie(ehrId: string){
  let url =environment.betterResourceUrl+'/view/Allergie';
  return this.http.get<any>(url,{
    params:{
      ehrid:ehrId
    }
  });
}
}
